import React, { useRef } from 'react'
import styles from '../styles/RatingSection.module.css'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { MdOutlineStarRate } from "react-icons/md";
import user1 from '../../../../assets/Landing/user1.jpg'
import user2 from '../../../../assets/Landing/user2.jpg'

const RatingSection = () => {

    const slider = useRef(null)

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className={styles.rating_section_container}>
            <div className={styles.testimonial_slider_wrapper}>
                <style>
                    {`
                    .slick-slider .slick-list {
                        padding: 32px 0!important;
                    }

                    .slick-dots li.slick-active button:before {
                        color: rgba(22, 166, 106, 1) !important;
                    }

                    .slick-dots li button:before {
                        color: rgba(22, 166, 106, 1) !important;
                    }
                `}
                </style>

                {/* <button onClick={() => slider.current.slickPrev()} className={styles.slider_ctrl_btn}><FaChevronLeft /></button> */}

                <div className={styles.slider_container}>
                    <Slider ref={slider} {...settings}>
                        <div className={styles.testimonial_slider_card}>
                            <div className={styles.slider_card_body}>
                                <p>With Elmaam, we've transformed the way we train our employees. The mobile access, structured modules, and insightful reports have made learning more efficient across our organization.</p>
                            </div>
                            <div className={styles.slider_card_footer}>
                                {/* <img src={user1} alt="" /> */}
                                <h6>Imran Ahmed</h6>
                            </div>
                        </div>
                        <div className={styles.testimonial_slider_card}>
                            <div className={styles.slider_card_body}>
                                <p>Elmaam has brought consistency and clarity to our training process. The platform is easy to use, and the assessments and reports help us track progress and make smarter decisions.</p>
                            </div>
                            <div className={styles.slider_card_footer}>
                                {/* <img src={user2} alt="" /> */}
                                <h6>Sara Al Mahoroqui</h6>
                            </div>
                        </div>
                        <div className={styles.testimonial_slider_card}>
                            <div className={styles.slider_card_body}>
                                <p>Elmaam has completely streamlined our employee development. From onboarding to ongoing training, everything is organized, accessible, and aligned with our goals.</p>
                            </div>
                            <div className={styles.slider_card_footer}>
                                {/* <img src={user1} alt="" /> */}
                                <h6>Mohammed Al Rahabi</h6>
                            </div>
                        </div>
                    </Slider>
                </div>

                {/* <button onClick={() => slider.current.slickNext()} className={styles.slider_ctrl_btn}><FaChevronRight /></button> */}
            </div>
        </div>
    )
}

export default RatingSection